import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { API_ROOT, Zone, TerrorZone, GetHistoryResponse, VouchRequest } from '@tt/common';
import axios from 'axios';
import { AsyncStatus } from "../../app/interface";

axios.defaults.withCredentials = true;

export interface TrackerState {
  readonly currentZone: CurrentZone;
  readonly currentZoneLoadStatus: AsyncStatus;
  readonly pastZones: Array<Zone>;
  readonly nextHistoryIndex?: string;
  readonly historyLoadStatus: AsyncStatus;
}

export interface CurrentZone {
  readonly candidates: Array<Zone>;
}

const initialState: TrackerState = {
  currentZone: {
    candidates: [],
  },
  currentZoneLoadStatus: AsyncStatus.NONE,
  pastZones: [],
  historyLoadStatus: AsyncStatus.NONE,
}

const getVouches = async (ladder: string) => {
  return axios.get(`${API_ROOT}/vouch`, {
    params: {
      ladder,
    }
  });
}

export const loadCurrentZone = createAsyncThunk(
  'tracker/loadCurrentZone',
  async (ladder: string): Promise<CurrentZone> => {
    const response = await getVouches(ladder);
    console.log(response)
    return response.data;
  }
)

export const refreshCurrentZone = createAsyncThunk(
  'tracker/refreshCurrentZone',
  async (ladder: string): Promise<CurrentZone> => {
    const response = await getVouches(ladder);
    console.log(response)
    return response.data;
  }
);

export const vouchCurrentZone = createAsyncThunk(
  'tracker/vouchCurrentZone',
  async (props: VouchRequest): Promise<CurrentZone> => {
    const response = await axios.post(`${API_ROOT}/vouch`, props);
    console.log('Vouched');
    console.log(response);
    return response.data;
  }
)

export interface LoadHistoryProps {
  readonly ladder: string;
  readonly numHours: number;
  startingHour?: string;
}
export const loadHistory = createAsyncThunk(
  'tracker/loadHistory',
  async (props: LoadHistoryProps): Promise<GetHistoryResponse> => {
    const response = await axios.get(`${API_ROOT}/history`, {
      params: props
    });
    console.log(response);
    return response.data;
  }
)

export const trackerSlice = createSlice({
  name: 'tracker',
  initialState,
  reducers: {

  },
  extraReducers: builder => 
    builder
      .addCase(loadCurrentZone.pending, state => {
        state.currentZoneLoadStatus = AsyncStatus.LOADING;
      })
      .addCase(loadCurrentZone.fulfilled, (state, action: PayloadAction<CurrentZone>) => {
        state.currentZone = action.payload;
        state.currentZoneLoadStatus = AsyncStatus.IDLE;
      })
      .addCase(refreshCurrentZone.fulfilled, (state, action: PayloadAction<CurrentZone>) => {
        state.currentZone = action.payload;
      })
      .addCase(loadHistory.pending, state => {
        state.historyLoadStatus = AsyncStatus.LOADING;
      })
      .addCase(loadHistory.fulfilled, (state, action: PayloadAction<GetHistoryResponse>) => {
        state.pastZones = [...state.pastZones, ...action.payload.history];
        state.nextHistoryIndex = action.payload.nextIndex;
        state.historyLoadStatus = AsyncStatus.IDLE;
      })
      .addCase(vouchCurrentZone.fulfilled, (state, action: PayloadAction<CurrentZone>) => {
        state.currentZone = action.payload;
      })
});

export default trackerSlice.reducer;

const delay = (ms: number) => new Promise(res => setTimeout(res, ms));